exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "results .header{height:10vh;text-align:center}results .graphs{height:50vh}results .graphs .graph-header{display:flex;justify-content:space-between;align-items:center}results h2{color:#3f51b5;font-size:2em;margin-bottom:-10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/results/results.scss
// module id = 630
// module chunks = 0